import { combineReducers } from 'redux'
import help from './help'
import faq from './faq'
import page from './page'

export default combineReducers({
  help,
  faq,
  page
})
